import React, { useState } from 'react'
import clsx from 'clsx'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import PersonAddIcon from '@material-ui/icons/PersonAdd'

import { SECONDARY } from 'app/constants/button'
import { SubscriberMenuAction } from 'app/constants/subscriberCRM'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const Approve = (props) => {
  const {
    closeMenu = () => {},
    onAction,
    rootAdmin = {},
    selected = [],
    selectedCount = null,
    totalSelected = null,
  } = props

  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <div>
      {!isNil(rootAdmin) && selectedCount > 0 && (
        <Typography
          className={clsx(
            'text-14 text-primary font-500 cursor-pointer whitespace-nowrap',
          )}
          onClick={handleOpen}
        >
          {formatMessage(
            {
              id: 'action.approve',
            },
            { value: `(${selectedCount.toLocaleString()})` },
          )}
        </Typography>
      )}
      {isNil(selectedCount) && (
        <MenuItem onClick={() => handleOpen()} className="space-x-5">
          <PersonAddIcon fontSize="small" className="text-blue-500" />
          <Typography className="text-14 font-400 text-blue-500">
            {formatMessage({
              id: 'crm.form.approve',
            })}
          </Typography>
        </MenuItem>
      )}

      <SubmitDialog
        id="dialog-approve-subscriber"
        open={isOpen}
        type={SECONDARY}
        title={formatMessage(
          {
            id: 'subscriber.approve.title2',
          },
          {
            count: isNil(selectedCount) ? 1 : selectedCount,
          },
        )}
        description={formatMessage(
          {
            id: 'subscriber.approve.description2',
          },
          {
            count: isNil(selectedCount) ? 1 : selectedCount,
          },
        )}
        submitText={formatMessage({
          id: 'crm.form.approve',
        })}
        onSubmit={() => {
          onAction(SubscriberMenuAction.APPROVE, selected)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </div>
  )
}

Approve.propTypes = {
  onAction: PropTypes.func,
  selected: PropTypes.array,
  closeMenu: PropTypes.func,
  className: PropTypes.string,
  rootAdmin: PropTypes.object,
  selectedCount: PropTypes.number,
}

export default Approve
